export enum PropertyListingTypes {
  ENTIREHOME = 'ENTIREHOME',
  SHAREDROOM = 'SHAREDROOM',
  PRIVATEROOM = 'PRIVATEROOM',
  HOTELROOM = 'HOTELROOM',
}
